module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_2005-147f631398644c202a33267c016ffa72.jpg";